import React from 'react';
import styled from 'styled-components';

interface ContainerProps {
  children: React.ReactNode;
  maxWidth?: string;
  padding?: string;
  className?: string;
}

const StyledContainer = styled.div<ContainerProps>`
  width: 100%;
  max-width: ${props => props.maxWidth || '1200px'};
  margin: 0 auto;
  padding: ${props => props.padding || `0 ${props.theme.spacing.md}`};
`;

const Container: React.FC<ContainerProps> = ({
  children,
  maxWidth,
  padding,
  className,
}) => {
  return (
    <StyledContainer
      maxWidth={maxWidth}
      padding={padding}
      className={className}
    >
      {children}
    </StyledContainer>
  );
};

export default Container; 